import { INDUSTRIES } from "shared/lib/constants/industry";
import { clsxMerge } from "shared/lib/helpers";

export const CampaignCardIndustryPill = ({
  industry,
  className,
}: {
  industry: string;
  className?: string;
}) => {
  return industry ? (
    <div
      className={clsxMerge(
        "typography-body-4-semibold px-2 py-1",
        "rounded-[4px] border-none",
        "bg-[#014DFE1A] text-[#014DFE]",
        "line-clamp-2",
        className
      )}
    >
      {INDUSTRIES.find(({ value }) => value === industry)?.label || industry}
    </div>
  ) : null;
};
